import React from 'react';

import Widget from './Widget';
import Settings from './Settings';
import Dashboard from './Dashboard';

const render = props => {
  const pathArray = location.pathname.split('/');
  const relativePath = pathArray[pathArray.length - 1];
  switch (relativePath) {
    case 'widget':
      return <Widget {...props} />;
    case 'settings':
      return <Settings {...props} />;
    case 'dashboard':
      return <Dashboard {...props} />;
    default:
      return null;
  }
};

export default render;
